import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "./authSlice";

const persistConfig = {
  key: "root",
  storage,
};
const Rootreducer = combineReducers({
  authSlice,
});
const persistedReducer = persistReducer(persistConfig, Rootreducer);
const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
export default store;
